import { Box } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
export const CategoryBar = styled(Box, {
    shouldForwardProp: prop => prop !== 'isDropdownOpen',
}) `
  z-index: 6;
  position: sticky;
  top: var(--cb-header-height);
  left: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.color.background.secondary};
  pointer-events: ${({ isDropdownOpen }) => (isDropdownOpen ? 'none' : '')};
`;
// padding-bottom needs to be hardcoded since the border-bottom is not following our spacing system
export const CategoryNavigationGroup = styled('li', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  position: relative;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[400]} 0 1.3rem`};
  list-style-type: none;
  border-bottom: 3px solid
    ${({ isActive, theme }) => (isActive ? theme.color.border.secondary : 'transparent')};
  transition: border-bottom 150ms ease-in-out;
`;
const fadeInCategoryGroup = () => keyframes `
    0% {
      top: 95%;
      opacity: 0;
    }
    100% {
      top: 100%;
      opacity: 1;
    }
  `;
export const CategoryGroupBox = styled(Box) `
  z-index: 6;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing[600]};
  background-color: ${({ theme }) => theme.color.background.base};
  border-top: 1px solid ${({ theme }) => theme.color.border.base};
  border-bottom: 1px solid ${({ theme }) => theme.color.border.base};
  opacity: 1;
  animation: ${fadeInCategoryGroup()} 150ms ease-in-out;
`;
// TODO: Change background-color back to DS backdropAlternativeDimmed when color is fixed.
export const Backdrop = styled(Box, {
    shouldForwardProp: prop => prop !== 'show',
}) `
  user-select: none;
  pointer-events: none;
  z-index: 5;
  position: fixed;
  width: 100%;
  height: calc(100% - var(--cb-header-height));
  left: 0;
  top: var(--cb-header-height);
  opacity: ${({ show }) => (show ? 1 : 0)};
  will-change: opacity;
  background-color: rgb(40 93 171 / 15%);
  transition: ${({ show }) => (show ? 'opacity 150ms ease-in-out' : 'unset')};
`;
export const CategoryColumnBox = styled(Box) `
  column-count: 2;
  list-style-type: none;
  padding: 0;
  margin: 0;

  ${({ theme }) => theme.breakpoint.minWidth('lg')} {
    column-count: 4;
  }
`;
//# sourceMappingURL=CategoryNavigationBar.styled.js.map